import { parseSanitizedHtml } from "@/utils/sanitizeHtml";
import BehaviorStatic from "./BehaviorStatic";
import { useEffect } from "react";
import Helpers from "@/Helpers";

export default function BehaviorsStatic(props) {
   const { sectionData, setValue, values } = props;
   const currentSection = sectionData?.currentSection;
   const lang = sectionData?.lang || sectionData?.testState?.lang || "eng";
   const content: Record<string, string> = Helpers.getSectionContent(currentSection, lang);
   const elements = Helpers.getSectionElements(content);

   const contentItems = Array.isArray(elements?.items) ? elements.items : [];
   const instructionsHtml = Helpers.getSectionHtmlValue(content, "instructions");

   useEffect(() => {
      if (typeof sectionData?.registerSection !== "function") return;
      sectionData.registerSection( 767, contentItems.length);
   }, [currentSection?.name]);


   async function setValueAsync(childId, value) {
      if (setValue)
         setValue( childId, value);
      else {
         if (sectionData && sectionData.onAnswer)
            await sectionData.onAnswer(childId, value);
      }
   }

   return (
      <div className="behaviorsStatic page" >
         <div className="instructions left">
            <p>{parseSanitizedHtml(instructionsHtml)}</p>
         </div>
         <div className="content center">
                  {contentItems.map((item, i) => {
                     return (
                        <BehaviorStatic
                           key={i}
                           data={item}
                           value={values[item.id + currentSection.formId]||0}
                           setValue={setValueAsync}
                        />
                     );
                  })}
         </div>
      </div>
   );
}


